export default {
  setToken(value) {
    window.localStorage.setItem("token", value);
  },

  setUser(user) {
    window.localStorage.setItem(
      "user",
      JSON.stringify({
        id: user.id,
        name: user.name,
        email: user.email,
        onboarding_verified_at: user.onboarding_verified_at,
        currency: user.currency,
        currentPlan: user.currentPlan
      })
    );
  },

  setAccount(account) {
    window.localStorage.setItem(
      "account",
      JSON.stringify({
        subDomain: account.subDomain,
        settings: account.settings,
        address: account.address,
        company: account.company,
        instructions: account.instructions,
        emailSignature: account.emailSignature,
        isNewScopesAvailable: account.isNewScopesAvailable,
        customNetTerms: account.customNetTerms,
        multipleEmailAddresses: account.multipleEmailAddresses
      })
    );
  },

  getToken() {
    let token = window.localStorage.getItem("token");
    if (!token) {
      return null;
    } else {
      return token;
    }
  },

  getUser() {
    let user = window.localStorage.getItem("user");
    if (!user) {
      this.destroyToken();
      return null;
    } else {
      return user;
    }
  },

  getAccount() {
    let account = window.localStorage.getItem("account");
    if (!account) {
      this.destroyToken();
      return null;
    } else {
      return account;
    }
  },

  destroyAccount() {
    window.localStorage.removeItem("account");
  },
  destroyToken() {
    window.localStorage.removeItem("token");
  },
  destroyUser() {
    window.localStorage.removeItem("user");
  },
  logout() {
    this.destroyUser();
    this.destroyToken();
  },

  isAuthenticated() {
    if (this.getToken()) {
      return true;
    }
    return false;
  }
};
